import classNames from 'classnames';
import React, { useState } from 'react';
import { IconButton } from '../../components/Button';
import SVGIcon from '../../components/SVGIcon';
import clearIcon from '../../icons/non-prefilled/16x16/clear.svg';
import searchIcon from '../../icons/non-prefilled/16x16/search.svg';
import * as styles from './ExtensionSearchBar.module.scss';

interface ExtensionSearchBarProps {
  stuck: boolean;
  onClose: () => void;
  onSubmit: (keyword: string) => void;
  onMouseEnter: () => void;
}

const ExtensionSearchBar = ({
  stuck,
  onClose,
  onSubmit,
  onMouseEnter,
}: ExtensionSearchBarProps) => {
  const [keyword, setKeyword] = useState('');

  return (
    <form
      className={classNames(styles.container, { [styles.stuck]: stuck })}
      onSubmit={(e) => {
        onSubmit(keyword);
        e.preventDefault();
      }}
      onMouseEnter={onMouseEnter}
    >
      <input
        type="text"
        name="keyword"
        value={keyword}
        placeholder="Search for knowledge"
        onChange={(e) => {
          const newKeyword = e.target.value;
          setKeyword(newKeyword);
          if (!newKeyword) {
            onSubmit('');
          }
        }}
        aria-label="Search input"
      />
      <SVGIcon className={styles.icon}>{searchIcon}</SVGIcon>
      <div className={styles.clearButtonContainer}>
        <IconButton
          className={styles.clearButton}
          onClick={onClose}
          aria-label="Close Slab"
          size="xl"
        >
          {clearIcon}
        </IconButton>
      </div>
    </form>
  );
};

export default ExtensionSearchBar;
